var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", md8: "", "offset-md2": "" } }, [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "my-queue",
                    attrs: { color: "grey", dark: "", large: "" },
                    on: {
                      click: function($event) {
                        return _vm.$router.replace("/MyQueue")
                      }
                    }
                  },
                  [_vm._v("My Queue")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md8: "", "offset-md2": "" } },
            [
              _c("v-flex", { attrs: { xs12: "", md4: "", left: "" } }, [
                _c("h1", { staticClass: "mb-3 text-xs-center greyy" }, [
                  _vm._v("Open Orders")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "circle" }, [
                  _vm.freeSamplesLoading
                    ? _c(
                        "div",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "pinkk" }, [
                        _vm._v(
                          "\n            " + _vm._s(_vm.total) + "\n          "
                        )
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "", md4: "", left: "" } }, [
                _c("h1", { staticClass: "mb-3 text-xs-center greyy" }, [
                  _vm._v("Unassigned Orders")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "circle" }, [
                  _vm.freeSamplesLoading
                    ? _c(
                        "div",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "pinkk" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.unAssignedTotal) +
                            "\n          "
                        )
                      ])
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "", md4: "", left: "" } }, [
                _c("h1", { staticClass: "mb-3 text-xs-center greyy" }, [
                  _vm._v("Assigned Orders")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "circle" }, [
                  _vm.freeSamplesLoading
                    ? _c(
                        "div",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.assignedTotal) +
                            "\n          "
                        )
                      ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "table-responsive",
                  attrs: { xs12: "", md12: "" }
                },
                [
                  _c(
                    "table",
                    {
                      staticClass: "text-xs-center greyy",
                      attrs: { width: "100%" }
                    },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c(
                            "th",
                            { attrs: { width: "20%" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "greyy assign-btn",
                                  attrs: {
                                    disabled: _vm.selected.length === 0,
                                    large: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.Assign()
                                    }
                                  }
                                },
                                [_vm._v("Assign")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-xs-left",
                              attrs: { width: "20%" }
                            },
                            [_vm._v("Order Code")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-xs-left",
                              attrs: { width: "20%" }
                            },
                            [_vm._v("Name")]
                          ),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "20%" } }, [
                            _vm._v("No. Samples")
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-xs-left",
                              attrs: { width: "20%" }
                            },
                            [_vm._v("Date")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.orders.length
                        ? _c(
                            "tbody",
                            _vm._l(_vm.orders, function(order, index) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  [
                                    _c("v-checkbox", {
                                      staticClass:
                                        "align-center justify-center",
                                      attrs: {
                                        value: order._id,
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.selected,
                                        callback: function($$v) {
                                          _vm.selected = $$v
                                        },
                                        expression: "selected"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(order.orderCode))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(order.customerID.firstName) +
                                      " " +
                                      _vm._s(order.customerID.lastName)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(order.freeSamples.length))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      new Date(order.date).getDate() +
                                        "/" +
                                        (new Date(order.date).getMonth() + 1) +
                                        "/" +
                                        new Date(order.date).getFullYear()
                                    )
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        : _c("tbody", [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "5" } },
                                [
                                  _vm.freeSamplesLoading
                                    ? _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "justify-center": "",
                                            "align-center": "",
                                            "mt-5": ""
                                          }
                                        },
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              indeterminate: "",
                                              color: "primary"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "justify-center": "",
                                            "align-center": "",
                                            "mt-5": ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  No Records found\n                "
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            ])
                          ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe44d736", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe44d736","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/freeSamples/FreeSamplesNew.vue
// module id = null
// module chunks = 